// import '../../Style/pin.css'
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import axios from 'axios';

import '../../../Style/online-train/auth.css'

function Authendicate() {
  const [formType, setFormType] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [mes, setMes] = useState('');

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const formTypeParam = queryParams.get('formType');
    setFormType(formTypeParam);

    const savedPin = Cookies.get('pin-verified');
    if (savedPin === 'true' && formTypeParam) {
      navigate(`/${formTypeParam}`);
    }
  }, [location, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://amigomath.com/__Login.php', new URLSearchParams({
        email,
        password,
      }));
      if (response.data.status == "success") {  // Assuming response.data.success indicates login success
        Cookies.set('pin-verified', 'true', { expires: 1/24 });  // Set cookie to expire in 1 day
        formType == null? navigate("/") : navigate(`/${formType}`);
      } else {
        setError("Invalid credentials. Please try again.");
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Error logging in');
    }
  };

  return (
    <div className='login'>
      <form className='login-form' onSubmit={handleSubmit}>
        <div>
          <label>Email:</label>
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && <h1>{error}</h1>}
        </div>
        <button className='login-btn' type="submit">Login</button>
      </form>
    </div>
  );
}

export default Authendicate;



